import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import LMS from '../../Assets/Projects/lms.png';
import WeChat from '../../Assets/Projects/wechat.png';
import Pokedex from '../../Assets/Projects/pokedex.png';
import Gblogs from '../../Assets/Projects/gblogs.png';
import Kola from '../../Assets/Projects/kola.jpg';

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={LMS}
              isBlog={false}
              title="LMS"
              description="Our learning management system (LMS) is a robust platform developed using React.js, Node.js, Express.js, MongoDB, Tailwind CSS, and Redux. It offers comprehensive features such as user authentication, payment integration, video management, and course creation and editing capabilities."
              ghLink="https://github.com/AyushGodbole/LMS_Ayush"
              demoLink="https://dummy-frontend-one.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={WeChat}
              isBlog={false}
              title="We-Chat"
              description="We-Chat is a real-time chat application powered by React.js, MongoDB, Express.js, Node.js, and Socket.io. It features seamless authentication, instant messaging with real-time updates, and a variety of emojis and text formatting options for expressive conversations."
              ghLink="https://github.com/AyushGodbole/we-chat"
              demoLink="https://we-chat-sigma.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Gblogs}
              isBlog={false}
              title="G-Blogs"
              description="A dynamic blog application crafted with React.js, Express.js, Node.js, MongoDB (MERN stack), and Material-UI. This platform offers robust features including secure authentication, intuitive blog creation, seamless editing and deletion capabilities, and a theme toggler for personalized user experiences. Whether you're a blogger or reader, our application ensures a smooth and engaging interface to explore and interact with diverse content."
              ghLink="https://github.com/AyushGodbole/vecros_full_stack"
              demoLink="https://vecros-full-stack.vercel.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Pokedex}
              isBlog={false}
              title="Pokedex"
              description="Explore the world of Pokémon with our Pokédex, a React.js application that fetches data from PokeAPI. Designed as a learning tool for API integration and React development, our Pokédex showcases detailed Pokémon information and includes a search feature for quick access. Dive into the vast Pokémon universe, where each search reveals comprehensive data, providing a fun and educational experience for all trainers."
              ghLink="https://github.com/AyushGodbole/pokedex-reactjs"
              demoLink="https://pokedexayush.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Kola}
              isBlog={false}
              title="Kola"
              description="Introducing Kola, an intuitive online cab booking application crafted with Flutter and Kotlin. Enjoy seamless map integration for real-time navigation, robust authentication for security, and effortless cab booking and cancellation features. Kola ensures reliable transportation solutions at your fingertips, making travel convenient and efficient."
              ghLink="https://github.com/AyushGodbole/Kola-flutter"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
